// extracted by mini-css-extract-plugin
module.exports = {"section":"MainNavigation_section__2RSi4","logo":"MainNavigation_logo__1TgMx","nav":"MainNavigation_nav__3DXok","active":"MainNavigation_active__ydtOF"};